'use client';

import AppLayout from '@/components/AppLayout';
import SupplierOnboardingContent from './components/SupplierOnboardingContent';

export default function SupplierOnboardingPage() {
  return (
    <AppLayout>
      <SupplierOnboardingContent />
    </AppLayout>
  );
}
